// formConfigVaga.js

export const formStructure = [
  [
    { name: 'Nome', label: 'Nome', placeholder: 'Ex.: Isaque', component: 'FormField', type: 'text', colProps: { md: 6 }, required: true, maxLength: 120, validation: { required: 'Nome e obrigatorio' } },
    { name: 'Sobrenome', label: 'Sobrenome', placeholder: 'Ex.: de Souza', component: 'FormField', type: 'text', colProps: { md: 6 }, required: true, maxLength: 120, validation: { required: 'Sobrenome e obrigatorio' } },
  ],

  [
    { name: 'Email', label: 'E-mail', placeholder: 'exemplo@dominio.com', component: 'FormField', type: 'email', colProps: { md: 6 }, required: true, validation: { required: 'E-mail e obrigatorio' } },
    { name: 'NumeroTelefone', label: 'Telefone', placeholder: '(00) 00000-0000', component: 'FormField', type: 'text', colProps: { md: 6 }, maxLength: 16 },
  ],

  [
    { name: 'CPF', label: 'CPF', placeholder: '000.000.000-00', component: 'FormField', type: 'text', colProps: { md: 6 }, required: true, maxLength: 14, validation: { required: 'CPF e obrigatorio' } },
    { name: 'PIS', label: 'PIS', placeholder: 'Ex.: 123.4567.89-0', component: 'FormField', type: 'text', colProps: { md: 6 }, maxLength: 20 },
  ],

  [
    { name: 'TituloVaga', label: 'Titulo da vaga pretendida', placeholder: 'Ex.: 3', component: 'FormField', type: 'text', colProps: { md: 6 } },
    { name: 'Escolaridade', label: 'Escolaridade', placeholder: 'Selecione...', component: 'SearchSelect', isMulti: false, colProps: { md: 6 },
      options: [
        { label: 'Fundamental', value: 'fundamental' },
        { label: 'Medio', value: 'medio' },
        { label: 'Tecnico', value: 'tecnico' },
        { label: 'Superior', value: 'superior' },
        { label: 'Pos-graduacao', value: 'pos' },
        { label: 'Mestrado', value: 'mestrado' },
        { label: 'Doutorado', value: 'doutorado' },
      ],
      defaultValue: '',
    },
  ],

  [
    { name: 'EstadoLocalizacao', label: 'Estado (UF)', placeholder: 'Ex.: SC', component: 'FormField', type: 'text', colProps: { md: 4 }, maxLength: 2 },
    { name: 'CidadeLocalizacao', label: 'Cidade', placeholder: 'Ex.: Barra Velha', component: 'FormField', type: 'text', colProps: { md: 4 }, maxLength: 120 },
    { name: 'BairroLocalizacao', label: 'Bairro', placeholder: 'Ex.: Jardim Los Angeles', component: 'FormField', type: 'text', colProps: { md: 4 }, maxLength: 120 },
  ],

  [
    { name: 'RuaLocalizacao', label: 'Rua', placeholder: 'Ex.: Rua Lucio Brugnado', component: 'FormField', type: 'text', colProps: { md: 4 }, maxLength: 200 },
    { name: 'NumeroLocalizacao', label: 'Numero', placeholder: 'Ex.: 211', component: 'FormField', type: 'text', colProps: { md: 4 }, maxLength: 20 },
    { name: 'CEPLocalizacao', label: 'CEP', placeholder: 'Ex.: 88390-000', component: 'FormField', type: 'text', colProps: { md: 4 }, maxLength: 9 },
  ],

  [
    { name: 'ComplementoLocalizacao', label: 'Complemento', placeholder: 'Ex.: Casa / Bloco / Referencia...', component: 'FormField', type: 'text', colProps: { md: 12 }, maxLength: 200 },
  ],

  [
    { name: 'NumeroCNH', label: 'Numero da CNH', placeholder: 'Ex.: 99999999999', component: 'FormField', type: 'text', colProps: { md: 4 }, maxLength: 20 },
    { name: 'CategoriaCNH', label: 'Categoria CNH', placeholder: 'Selecione...', component: 'SearchSelect', isMulti: false, colProps: { md: 4 },
      options: [
        { label: 'A', value: 'A' },
        { label: 'B', value: 'B' },
        { label: 'C', value: 'C' },
        { label: 'D', value: 'D' },
        { label: 'E', value: 'E' },
        { label: 'AB', value: 'AB' },
      ],
      defaultValue: '',
    },
    { name: 'ValidadeCNH', label: 'Validade da CNH', placeholder: 'Selecione a data', component: 'FormField', type: 'date', colProps: { md: 4 } },
  ],

  [
    { name: 'ImgCurriculo', label: 'Curriculo (URL)', placeholder: 'URL do curriculo', component: 'FormField', type: 'text', colProps: { md: 6 }, readOnly: true },
    { name: 'ImgCNH', label: 'CNH (URL)', placeholder: 'URL da CNH', component: 'FormField', type: 'text', colProps: { md: 6 }, readOnly: true },
  ],
];

export const formTabs = (initialValues) => {
  const tituloCandidato = initialValues?.Nome ? ` - ${initialValues.Nome} ${initialValues?.Sobrenome || ''}` : '';

  return [
    {
      id: 'identificacao',
      label: 'Identificacao & Contato',
      sections: [
        { title: `Identificacao & Contato${tituloCandidato}`, rows: [0, 1] },
      ],
    },
    {
      id: 'documentos',
      label: 'Documentos',
      sections: [
        { title: 'Documentos', rows: [2] },
      ],
    },
    {
      id: 'vaga',
      label: 'Vaga & Escolaridade',
      sections: [
        { title: 'Vaga & Escolaridade', rows: [3] },
      ],
    },
    {
      id: 'endereco',
      label: 'Endereco',
      sections: [
        { title: 'Endereco', rows: [4, 5, 6] },
      ],
      renderExtra: 'map',
    },
    {
      id: 'cnh',
      label: 'CNH & Anexos',
      sections: [
        { title: 'CNH', rows: [7] },
        { title: 'Anexos', rows: [8] },
      ],
    },
    {
      id: 'experiencias',
      label: 'Experiencias & Habilidades',
      sections: [],
      render: 'experiencias',
    },
  ];
};

export const formSections = (initialValues) => formTabs(initialValues).flatMap((tab) => tab.sections);

export const validateForm = (values) => {
  const errors = {};
  if (!values?.Nome?.trim()) errors.Nome = 'Nome e obrigatorio';
  if (!values?.Sobrenome?.trim()) errors.Sobrenome = 'Sobrenome e obrigatorio';
  if (!values?.Email?.trim()) errors.Email = 'E-mail e obrigatorio';
  if (!values?.CPF?.trim()) errors.CPF = 'CPF e obrigatorio';
  if (values?.NumeroCNH && !values?.CategoriaCNH) errors.CategoriaCNH = 'Informe a categoria da CNH';
  if (values?.NumeroCNH && !values?.ValidadeCNH) errors.ValidadeCNH = 'Informe a validade da CNH';
  return errors;
};
